module.exports = __webpack_public_path__ + "img/mv.af8da554.svg";